<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar ref="sidebarScrollArea" class="vs-con-loading__container scroll-area--data-list-add-new pt-4 pb-6" :settings="settings" id="uploadTaskDetails">
      <div class="pl-6 pr-6">
        <div v-if="this.$siteTypeId() != 1">
          <div>
            <label>Task Classification</label>
            <v-select class="mb-3" ref="taskClassificationTypeDropdown" placeholder="Search / Select Task Classification"  :options="taskClassificationTypeList" v-model="taskClassificationTypeText"></v-select>
          </div>
        </div>
        <div>
          <label ref="nameLabel">Name</label>
          <vs-input autocomplete="off" class="w-full mb-3" v-model="formData.name"/>

          <div style="display: inline-grid;">
            <label>Task Number</label>
            <vs-input-number class="numberinput" onClick="this.select();" v-model="formData.number" :min="styleB? 1 :0" />
          </div>

          <vs-divider>Allowed File Types</vs-divider>

          <vs-checkbox class="pb-2" color="success" v-model="formData.allowAudio">Audio</vs-checkbox>
          <vs-checkbox class="pb-2" color="success" v-model="formData.allowDocument">Document</vs-checkbox>
          <vs-checkbox class="pb-2" color="success" v-model="formData.allowImage">Image</vs-checkbox>
          <vs-checkbox class="pb-1" color="success" v-model="formData.allowVideo">Video</vs-checkbox>

          <vs-divider></vs-divider>
          <vs-checkbox v-show="this.$siteTypeId() != 1"  class="py-1" v-model="formData.timeActive">Time Spent</vs-checkbox>
          <div v-show="formData.timeActive">
            <label>Minimum Time (hours)</label>
            <v-select class="mb-3" placeholder="Choose a minimum time"  :options="times" v-model="minTimeDropdown"></v-select>
          </div>
          <vs-checkbox class="pt-1 pb-1" v-model="formData.allowMultiple">Allow Multiple Uploads</vs-checkbox>

          <vs-divider></vs-divider>

          <label>Title</label>
          <vs-input autocomplete="off" class="w-full mb-3" v-model="formData.title"/>
          <label>Content</label>
          <quill-editor v-model="formData.content" class="mb-3" :options="editorOption" />
          <label>Pinned Document</label>
          <div>
            <file-pond
              v-show="newFileSelected"
              id="filepond"
              ref="pond"
              :server="uploadLocation"
              label-idle="Drop document here or <span class='filepond--label-action'>Browse</span>"
              accepted-file-types="application/pdf, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
              :allow-multiple="false"
              :instant-upload="true"
              allowPaste=false
              :allow-image-preview="true"
              @processfile="uploadComplete"
              @removefile="fileRemoved"
            />
            <div v-show="!newFileSelected" class="vx-row" v-for="(document, index) in formData.documents" :key="index" style="justify-content: space-between;">
              <div class="vx-col" style="align-self: center;">
                <p><strong>{{ document.url.substring(document.url.indexOf('_') + 1) }}</strong></p>
              </div>
              <div class="vx-col">
                <vs-button size="small" color="danger" type="flat" icon-pack="feather" icon="icon-x" @click="clearDocuments"/>
              </div>
            </div>
          </div>
        </div>
        <div v-if="this.$siteTypeId() != 1">
          <vs-divider>Outcomes</vs-divider>

            <div>
              <label>Assessment Criteria</label>
              <v-select class="mb-2" ref="assessmentCriteriaDropdown" placeholder="Search / Select Assessment Criteria"  :options="assessmentCriteriaList" v-model="assessmentCriteriaText"></v-select>
            </div>
            <div>
              <label>Essential Embedded Knowledge</label>
              <v-select class="mb-2" ref="eEKDropdown" placeholder="Search / Select EEK"  :options="eekList" v-model="essentialEmbeddedKnowledgeText"></v-select>
            </div>
            <div>
              <label>Unit Standard</label>
              <v-select class="mb-2" ref="unitStandardDropdown" placeholder="Search / Select Unit Standard"  :options="unitStandardList" v-model="unitStandardText"></v-select>
            </div>
              <div>
                <label>Spesific Outcome</label>
                <v-select class="mb-2" ref="spesificOutcomeDropdown" placeholder="Search / Select Spesific Outcome"  :options="spesificOutcomeList" v-model="spesificOutcomeText"></v-select>
              </div>

        </div>
          <div v-if="!taskGroupId">
            <vs-divider>Go To</vs-divider>

            <div class="pt-1">
              <vs-radio v-model="gotoRadio" vs-value="existingTask">Existing Task</vs-radio>
            </div>
            <div class="pt-2">
              <vs-radio v-model="gotoRadio" vs-value="newTask">Create New Task</vs-radio>
            </div>
            <div class="pt-2">
              <vs-radio v-model="gotoRadio" vs-value="none">None</vs-radio>
            </div>


            <div class="pt-4" v-show="gotoRadio == 'existingTask'">
              <label>Go To</label>
              <vs-select placeholder="Search / Select Go To task" class="w-full pb-3" vs-multiple autocomplete v-model="formData.goTo">
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
              </vs-select>
              <div>
                <div style="margin-bottom: 8px; margin-top: 2px;">
                  <vs-checkbox color="success" v-model="formData.useCoins">Coins</vs-checkbox>
                </div>
                <div v-if="formData.useCoins && gotoRadio == 'existingTask'">
                  <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                    <vs-switch color="success" v-model="formData.isCoinsRecurring">
                      <span slot="on">Recurring</span>
                      <span slot="off">Once Only</span>
                    </vs-switch>
                    <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addCoins">
                      <span slot="on">Add</span>
                      <span slot="off">Deduct</span>
                    </vs-switch>
                  </div>
                  <label style="margin-left: 5px;">Coin Value</label>
                  <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.coinValue" />
                  <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
                </div>
            </div>
          </div>
        </div>

        <div class="pt-4" v-show="gotoRadio == 'newTask'">
          <label>New Task Type</label>
          <vs-select placeholder="Search / Select a Task Type" class="w-full pb-3" vs-multiple autocomplete v-model="formData.taskTypeId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in taskTypeList" />
          </vs-select>
          <div>
            <div style="margin-bottom: 8px; margin-top: 2px;">
              <vs-checkbox color="success" v-model="formData.useCoins">Coins</vs-checkbox>
            </div>
            <div v-if="formData.useCoins && gotoRadio == 'newTask'">
              <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                <vs-switch color="success" v-model="formData.isCoinsRecurring">
                  <span slot="on">Recurring</span>
                  <span slot="off">Once Only</span>
                </vs-switch>
                <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addCoins">
                  <span slot="on">Add</span>
                  <span slot="off">Deduct</span>
                </vs-switch>
              </div>
              <label style="margin-left: 5px;">Coin Value</label>
              <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.coinValue" />
              <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
            </div>
          </div>
        </div>

      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="addEditUpload" :disabled="isDisabled" ref="addupdateButton">{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" @click="deleteApproach" v-show="formData.id" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { quillEditor } from 'vue-quill-editor';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from 'vue-select'

import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    courseId: {
      type: String,
      required: true
    },
    moduleId: {
      type: String,
      required: true
    },
    nodeSelected: {
      type: Object,
      required: false
    },
    taskClassificationTypes: {
      type: Array,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    },
    gotoList: {
      type: Array,
      required: false
    },
    sourceTaskId: {
      type: Number,
      required: false
    },
    taskGroupId: {
      type: Number,
      required: false
    },
    taskTypeList: {
      type: Array,
      required: false
    },
    styleB: {
      type: Boolean,
      required: false
    },
    taskNumber:{
      type: Number,
      required: false
    }
  },

  data() {
    return {
      editorOption: {
        modules: {toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
          ]
        },
      },
      backgroundLoading:'#fff',
      formData: {
        id: 0,
        goTo: 0,
        name: "",
        moduleId: "",
        taskTypeId: 0,
        sourceTaskId: 0,
        allowAudio: false,
        allowDocument: false,
        allowImage: false,
        allowVideo: false,
        allowMultiple: false,
        title: "",
        content: "",
        hasLogs: false,
        useCoins: false,
        isCoinsRecurring: false,
        addCoins: true,
        coinValue: "",
        number: 0,
        documents: [],
        standalone: false,
        taskGroupId: 0,
        spesificOutcomeId: null,
        unitStandardId: null,
        assessmentCriteriaId: null,
        essentialEmbeddedKnowledgeId: null,
        taskClassificationTypeId: null,
        timeActive:false,
        minimumTime: 0
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      gotoRadio: "",
      newFileSelected: false,
      spesificOutcomeDropdown: null,
      unitStandardDropdown: null,
      assessmentCriteriaDropdown: null,
      eEKDropdown: null,
      taskClassificationTypeDropdown: null,
      spesificOutcomeList: [],
      unitStandardList: [],
      assessmentCriteriaList: [],
      eekList: [],
      taskClassificationTypeList: [],
      spesificOutcomeText: null,
      unitStandardText: null,
      assessmentCriteriaText: null,
      essentialEmbeddedKnowledgeText: null,
      taskClassificationTypeText: null,
      minTimeDropdown: 0,
      times: [
        { label: "1-3",
          value: 1
        },
        { label: "4-6",
          value: 2
        },
        { label: "7-9",
          value: 3
        },
        { label: "10-12",
          value: 4
        },
        { label: "13-15",
          value: 5
        },
        { label: "16-18",
          value: 6
        },
        { label: "19-21",
          value: 7
        },
        { label: "22-24",
          value: 8
        },
        { label: "25-27",
          value: 9
        },
        { label: "28-30",
          value: 10
        }
      ]
    };
  },
  computed: {
    isDisabled: function() {
      return !(this.formData.allowAudio || this.formData.allowDocument || this.formData.allowImage || this.formData.allowVideo);
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
  },
  watch: {
    isSidebarActive: function(val) {
      var self = this;

      if(val){
        var scrollOptions = {
          container: '#uploadTaskDetails',
          easing: 'ease-in',
          offset: -10000,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 0, scrollOptions);

        self.newFileSelected = false;

        var goToDisplayValue = 0;
        if(self.nodeSelected.uploadTask)
          goToDisplayValue = self.nodeSelected.uploadTask.goTo;
        else
          goToDisplayValue = 0;

        self.formData.moduleId = self.moduleId;

        self.taskClassificationTypeList = self.taskClassificationTypes;

        self.getEEK();
        self.getUnitStandard();
        self.getSpesificOutcome();
        self.GetAssessmentCriteria();
        
        if(self.nodeSelected.id){
          self.formData.id = self.nodeSelected.id;
          self.formData.name = self.nodeSelected.name;
          self.formData.sourceTaskId = self.sourceTaskId;
          self.formData.allowAudio = self.nodeSelected.uploadTask.allowAudio;
          self.formData.allowDocument = self.nodeSelected.uploadTask.allowDocument;
          self.formData.allowImage = self.nodeSelected.uploadTask.allowImage;
          self.formData.allowVideo = self.nodeSelected.uploadTask.allowVideo;
          self.formData.allowMultiple = self.nodeSelected.uploadTask.allowMultiple;
          self.formData.title = self.nodeSelected.uploadTask.title;
          self.formData.taskGroupId = self.taskGroupId;
          self.formData.content = self.nodeSelected.uploadTask.content;
          self.formData.hasLogs = self.nodeSelected.uploadTask.hasLogs;
          self.formData.useCoins = self.nodeSelected.uploadTask.coinValue ? true : false;
          self.formData.addCoins = self.nodeSelected.uploadTask.coinValue > 0 ? true : false;
          self.formData.isCoinsRecurring = self.nodeSelected.uploadTask.isCoinsRecurring;
          self.formData.coinValue = self.nodeSelected.uploadTask.coinValue > 0 ? self.nodeSelected.uploadTask.coinValue : (self.nodeSelected.uploadTask.coinValue * -1);
          self.formData.documents = self.nodeSelected.uploadTask.documents;

          self.formData.timeActive = self.nodeSelected.uploadTask.timeActive;
          
          if(self.nodeSelected.uploadTask.minimumTime)
          self.minTimeDropdown = self.times.filter(function(item){return item.value == self.nodeSelected.uploadTask.minimumTime.toString()})[0];
          else
          self.minTimeDropdown = self.times[0];

          self.taskClassificationTypeText = self.taskClassificationTypeList.filter(function(item){return item.value == self.nodeSelected.taskClassificationTypeId})[0];

          self.formData.standalone = false;

          if (self.formData.documents.length == 0)
            self.newFileSelected = true;

          if (self.nodeSelected.number)
            self.formData.number = self.nodeSelected.number;
          else
            self.formData.number = 0;
          
          if(goToDisplayValue != 0)
            self.formData.goTo = self.gotoList.filter(function(item){ return item.text.split(" ")[0] == goToDisplayValue; })[0].value;

          if(self.formData.goTo){
            self.gotoRadio = "existingTask";
          } else {
            self.gotoRadio = "none";
          }

        }else{
          this.initValues(self.sourceTaskId || 0);
        }
      }else {
        self.$refs.pond.removeFiles();
        var scrollOptions = {
          container: '#uploadTaskDetails',
          easing: 'ease-in',
          offset: -10000,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = self.$scrollTo(self.$refs["nameLabel"], 0, scrollOptions);
      }
    }
  },
  methods: {
    getEEK(){
      var self =this;

      var onSuccess = function (response) {
        self.eekList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.essentialEmbeddedKnowledgeText = self.eekList.filter(function(item){return item.value == self.nodeSelected.essentialEmbeddedKnowledgeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/EEK?courseId=" + self.courseId, onSuccess);
    },
    getUnitStandard(){
      var self =this;

      var onSuccess = function (response) {
        self.unitStandardList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.unitStandardText = self.unitStandardList.filter(function(item){return item.value == self.nodeSelected.unitStandardId})[0];
        }
      }

      self.$ajaxGet(self, "Course/UnitStandard?courseId=" + self.courseId, onSuccess);
    },
    getSpesificOutcome(){
      var self =this;

      var onSuccess = function (response) {
        self.spesificOutcomeList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.spesificOutcomeText = self.spesificOutcomeList.filter(function(item){return item.value == self.nodeSelected.spesificOutcomeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/SpecificOutcome?courseId=" + self.courseId, onSuccess);
    },
    GetAssessmentCriteria(){
      var self =this;

      var onSuccess = function (response) {
        self.assessmentCriteriaList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.assessmentCriteriaText = self.assessmentCriteriaList.filter(function(item){return item.value == self.nodeSelected.assessmentCriteriaId})[0];
        }
      }

      self.$ajaxGet(self, "Course/AssesmentCriteria?courseId=" + self.courseId, onSuccess);
    },
    initValues(val) {
      this.gotoRadio = "none";
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.sourceTaskId = 0;
      this.formData.useCoins = false;
      this.formData.addCoins = true;
      this.formData.isCoinsRecurring = false;
      this.formData.coinValue = "";
      if(val){
        this.formData.sourceTaskId = val;
      }
      this.formData.allowAudio = false;
      this.formData.allowDocument = false;
      this.formData.allowImage = false;
      this.formData.allowVideo = false;
      this.formData.allowMultiple = false;
      this.formData.title = "";
      this.formData.content = "";
      this.formData.timeActive = false;
      this.formData.minimumTime = 0;
      this.minTimeDropdown = 0;

      this.formData.number = this.taskNumber? this.taskNumber: 0;
      
      this.formData.goTo = "";
      this.formData.taskTypeId = 0;
      this.formData.documents = [];
      this.$refs.pond.removeFiles();
      this.newFileSelected = true;
      this.errors.clear();

      this.spesificOutcomeText= null;
      this.unitStandardText = null;
      this.assessmentCriteriaText = null;
      this.essentialEmbeddedKnowledgeText = null;
      this.taskClassificationTypeText = null;
    },
    saveData(val,taskTypeId){

      this.$emit('saveData',val,taskTypeId);
      this.$vs.loading.close(this.$refs.addupdateButton.$el);
      this.initValues(val);
    },
    addEditUpload() {
      var self = this;
      if (self.styleB && !(self.spesificOutcomeText && self.spesificOutcomeText.value)) {
        self.$vs.notify({
          title:'Warning',
          color: "warning",
          text: "Please select a Specific Outcome for the task",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-slash',
          time: 5000
        });
        return;
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnButton();
          
          var onSuccess = response => {
            if(self.gotoRadio == "newTask"){
              self.saveData( response.data, self.formData.taskTypeId );
            }
            else {
              self.saveData(0, self.formData.taskTypeId);
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Task Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            }
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
          };

          if(self.gotoRadio == "none" || self.gotoRadio == "newTask"){
            self.formData.goTo = "0";
          } else if (self.gotoRadio == "existingTask"){
            
          }
          self.formData.taskClassificationTypeId = self.taskClassificationTypeText ? self.taskClassificationTypeText.value: null;

          self.formData.unitStandardId = self.unitStandardText ? self.unitStandardText.value: null;

          self.formData.taskGroupId = self.taskGroupId ? self.taskGroupId: null;

          self.formData.essentialEmbeddedKnowledgeId = self.essentialEmbeddedKnowledgeText ? self.essentialEmbeddedKnowledgeText.value: null;

          self.formData.assessmentCriteriaId = self.assessmentCriteriaText ?  self.assessmentCriteriaText.value: null;

          self.formData.spesificOutcomeId = self.spesificOutcomeText ?  self.spesificOutcomeText.value: null;

          self.formData.minimumTime = self.minTimeDropdown ?  self.minTimeDropdown.value : null;

          self.formData.number = self.styleB? self.formData.number >=0  ? self.formData.number: self.formData.number: self.formData.number;

          self.$ajaxPost(self, "uploadtask/addedituploadtask", self.formData, onSuccess, onFinally);
        }
      });
    },
    deleteTask() {
      var self = this;
      self.showLoadingOnDeleteButton();
      if(self.formData.hasLogs)
        self.showLoadingOnCytoscape();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Task Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
        self.$vs.loading.close(self.$parent.$el);
      }

      self.$ajaxDelete(self, "uploadtask/deleteuploadtask/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnCytoscape(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    deleteApproach() {
      if(this.formData.hasLogs)
        this.openConfirm();
      else
        this.deleteTask();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: 'Are you sure you want to delete the selected upload task?',
        accept: this.deleteTask,
        acceptText: "Yes, delete",
        cancelText: "No, cancel"
      })
    },
    clearDocuments() {
      this.newFileSelected = true;
      this.formData.documents = [];
    },
    uploadComplete(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url)
        this.formData.documents.push({
          uploadTaskId: this.formData.id,
          url: response.url
        });
    },
    fileRemoved(error, file) {
      this.formData.documents = [];
    },
  },
  components: {
    VuePerfectScrollbar,
    quillEditor,
    'v-select': vSelect,
    FilePond
  }
};
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background

    {
      z-index: 52010;
    }

    /deep/ .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;
      .img-upload

      {
        margin-top: 2rem;
        .con-img-upload

        {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }

      }
    }
  }

  .filepond--wrapper {
    width: 100%;
  }


  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
